import { render } from "./GeneralTab.vue?vue&type=template&id=37d5c0fe&scoped=true&ts=true"
import script from "./GeneralTab.vue?vue&type=script&lang=ts"
export * from "./GeneralTab.vue?vue&type=script&lang=ts"

import "./GeneralTab.vue?vue&type=style&index=0&id=37d5c0fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d5c0fe"]])

export default __exports__